import React from 'react'
import Nav from './Nav'
import HomeContainer from './HomeContainer'
import Footer from './Footer'
import Console from './Console'
export default class HomePage extends React.Component {
    state = {
        consoleVisible: false,
    }
    componentDidMount() {
        var c = document.getElementById("main_back_canvas");
        var ctx = c.getContext("2d");
        c.height = window.innerHeight;
        c.width = window.innerWidth;
        var matrix = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ123456789@#$%^&*()*&^%+-/~{[|`]}";
        matrix = matrix.split("");
        var font_size = 10;
        var columns = c.width / font_size;
        var drops = [];
        for (var x = 0; x < columns; x++)
            drops[x] = 1;
        function draw() {
            ctx.fillStyle = "rgba(0, 0, 0, 0.04)";
            ctx.fillRect(0, 0, c.width, c.height);
            ctx.fillStyle = "#008a00";
            ctx.font = font_size + "px arial";
            for (var i = 0; i < drops.length; i++) {
                var text = matrix[Math.floor(Math.random() * matrix.length)];
                ctx.fillText(text, i * font_size, drops[i] * font_size);
                if (drops[i] * font_size > c.height && Math.random() > 0.975)
                    drops[i] = 0;
                drops[i]++;
            }
        }

        setInterval(draw, 35);
    }
    onClickConsole = () => {
        this.setState({ consoleVisible: !this.state.consoleVisible })
    }
    render() {
        return (
            <div>
                <canvas id="main_back_canvas" style={{ display: 'block', width: '100%', poition: 'fixed' }}></canvas>
                <div id='main_container_top_bog'>
                    <Nav />
                    {this.state.consoleVisible && <Console onClickConsole={this.onClickConsole} />}
                    <HomeContainer onClickConsole={this.onClickConsole} />
                    <Footer />
                </div>
            </div>
        )
    }
}